import { TranslatedError } from '@bridebook/toolbox/src';
import { CountryCodes, type Market } from '@bridebook/toolbox/src/gazetteer';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';

const getLocalisedSeason = (season: string, market: Market): string => {
  const i18n = getI18n();

  /**
   * @TODO: [i18n] This is likely not what we want to do here.
   */
  const isUK = market.country === CountryCodes.GB;

  switch (season) {
    case 'summer':
      return isUK ? i18n.t('season.summer.name') : i18n.t('season.summer.months');
    case 'autumn':
      return isUK ? i18n.t('season.autum.name') : i18n.t('season.autum.months');
    case 'winter':
      return isUK ? i18n.t('season.winter.name') : i18n.t('season.winter.months');
    case 'spring':
      return isUK ? i18n.t('season.spring.name') : i18n.t('season.spring.months');
    default:
      throw new TranslatedError('There is no such season', i18n.t('season.error'));
  }
};

export default getLocalisedSeason;
